import { IconButton } from '@travelnest/merlin.button-icon';
import * as React from 'react';

import { FormInputProps } from '../form-input/FormInput';

interface IFormNumberInputProps extends FormInputProps {
	widthtype?: 'narrow' | 'half' | 'normal' | 'wide' | 'full';
}

export const FormNumberInput: React.FC<IFormNumberInputProps> = ({ ...props }) => {

	const change = (increment: number) => {
		const next = parseInt((props.value || 0).toString(), 10) + increment;
		if (props.onChange) props.onChange({ target: { value: next } } as any);
	};
	const value = parseInt((props.value || 0).toString(), 10);
	const min = typeof props.min === 'undefined' ? -Infinity : parseInt(props.min.toString(), 10);
	const max = typeof props.max === 'undefined' ? Infinity : parseInt(props.max.toString(), 10);
	const minDisabled = (props.disabled || value <= min);
	const maxDisabled = (props.disabled || value >= max);
	const incrementValue = props.increment || 1;
	const formInputSize = `form__input--size-${props.widthtype || 'default'}`;
	const classList = ['form__input', 'form__input--number', formInputSize];

	if (props['is-valid'] === 'false' || props['is-valid'] === false) {
		classList.push('form__input--error');
	}

	return (
		<div className="form-number-input">
			<input className={classList.join(' ')} {...props} />
			<IconButton
				disabled={minDisabled}
				icon="minus"
				onClick={(e) => { if (!minDisabled) change(-incrementValue); e.preventDefault(); }} />
			<IconButton
				disabled={maxDisabled}
				icon="plus"
				onClick={(e) => { if (!maxDisabled) change(incrementValue); e.preventDefault(); }} />
		</div>
	);
};
